import { request } from './httpClient';

export function createQuote(body) {
  return request({ method: 'POST', url: '/v1/quote', data: body });
}

export function getQuotes(params) {
  return request({ method: 'GET', url: '/v1/quotes', params });
}

export function getQuote(quoteId) {
  return request({ method: 'GET', url: `/v1/quote/${encodeURIComponent(quoteId)}` });
}

export function getQuoteLines(quoteId, params) {
  return request({ method: 'GET', url: `/v1/quote/${encodeURIComponent(quoteId)}/lines`, params });
}

export function getQuoteLine(quoteId, lineId) {
  return request({ method: 'GET', url: `/v1/quote/${encodeURIComponent(quoteId)}/line/${encodeURIComponent(lineId)}` });
}

export function updateQuoteLine(quoteId, quoteLineId, body) {
  return request({
    method: 'POST',
    url: `/v1/quote/${encodeURIComponent(quoteId)}/line/${encodeURIComponent(quoteLineId)}`,
    data: body,
  });
}

export function getQuoteCounts(params) {
  return request({ method: 'GET', url: '/v1/quote/counts', params });
}

export function deleteQuote(quoteId) {
  return request({ method: 'DELETE', url: `/v1/quote/${encodeURIComponent(quoteId)}` });
}

export function deleteQuoteLine(quoteId, quoteLineId) {
  return request({
    method: 'DELETE',
    url: `/v1/quote/${encodeURIComponent(quoteId)}/line/${encodeURIComponent(quoteLineId)}`,
  });
}

